<template>
  <AboutDirectSchool :title="title" :locations="locations" :people="people" />
</template>

<script>
import AboutDirectSchool from "@/components/AboutDirectSchool.vue";

export default {
  components: {
    AboutDirectSchool
  },
  data() {
    return {
      title: "⻄區校  國⼩部",
      locations: [
        {
          name: null,
          description: null,
          photo: require("../assets/west-1-photo.png"),
          address: "台中市西區三民路一段169號",
          phone: "04 2375-8082"
        }
      ],
      people: [
        {
          title: "國小部主任",
          photo: require("../assets/west-1-director.png"),
          name: "徐韶霙"
        }
      ]
    };
  }
};
</script>

<style></style>
